<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">알림톡 발송</span>
            <span class="txt">센터 내 전자계약 서류 알림톡 발송내역과 템플릿을 관리할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <button class="on">기본정보</button>
                <button @click="onClickRouter('/madmin/noti/talk')">알림톡 발송내역</button>
                <button @click="onClickRouter('/madmin/noti/template')">템플릿 관리</button>
                <button @click="onClickRouter('/madmin/noti/status')">센터별 발송현황</button>
            </div>

            <!--            <p class='sub-title small'><strong>Send Info</strong></p>-->

            <div class="com-cont-wrap" v-if="isProfileComplete">
                <p class="sub-title small">발송 정보</p>
                <div class="com-card-input full other">
                    <div class="line">
                        <span class="tit">
                            플러스친구 아이디
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt plus-friend-id-input">
                            <input
                                type="text"
                                placeholder="@ 플러스 친구 검색용 아이디를 입력해주세요."
                                readonly
                                v-model="name"
                            />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            카테고리 코드
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt">
                            <input type="text" readonly v-model="selectedCategoryName" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="com-cont-wrap">
                <p class="sub-title small">발송 정보</p>
                <div class="com-card-input full other">
                    <div class="line">
                        <span class="tit">
                            플러스친구 아이디
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt plus-friend-id-input">
                            <input
                                type="text"
                                placeholder="@ 플러스 친구 검색용 아이디를 입력해주세요."
                                v-model="yellowId"
                            />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            휴대폰번호
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt input-btn-wrap">
                            <input
                                type="text"
                                placeholder="카카오 채널 관리자에 등록된 휴대폰 번호를 입력해주세요."
                                v-model="phoneNumber"
                                @input="phoneNumber = $event.target.value.replace(/\D/g, '')"
                            />
                            <button type="button" class="com-btn dark-gray" @click="registerPlusFriend">
                                인증 요청
                            </button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            인증번호 입력
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt">
                            <input type="text" placeholder="인증번호를 입력해주세요." v-model="token" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            카테고리 코드
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form
                                :select-data="['선택', ...categoryCodes.map((category) => category.name)]"
                                :select-value="['', selectedCategoryCode]"
                                @update:set="updateSelectedCategoryCode"
                                @update:selected="updateSelectedCategoryCode"
                            ></select-form>
                        </div>
                    </div>
                    <!-- <div class="line">
                        <span class="tit">
                            Category code (middle classification)
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form :select-data="['Select', ...subCategoryCodes]"
                                :select-value="['', selectedSubCategoryCode]" @update:set="updateSelectedSubCategoryCode"
                                @update:selected="updateSelectedSubCategoryCode"></select-form>
                        </div>
                    </div> -->
                    <div class="bottom-btn">
                        <button class="com-btn" @click="resetFields">취소</button>
                        <button class="com-btn blue" @click="registerProfile">플러스친구 등록</button>
                    </div>
                </div>
            </div>

            <p class="sub-title small"><strong>계약서 발송 메시지</strong></p>

            <div class="rectangle-box contract-send">
                <div v-for='(template, index) in contractInfo' style="width: 25%">
                    <div class="contract-send-item">
                        <div class="general-input-component" style="margin-top: 0">
                            <div class="input-title" style="flex: 1">{{ template.title }}</div>
                            <div class="line">
                                <div class="line-wrap">
                                    <div class="check">
                                        <div class="com-design-check">
                                            <input
                                                :id="`check-sms-${template.type}-${index}`"
                                                type="checkbox"
                                                v-model="template.contractSend"
                                            />
                                            <label :for="`check-sms-${template.type}-${index}`"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">
                                템플릿 선택
                                <span class="imp">*</span>
                            </span>
                            <select-form
                                style="flex: 1"
                                :disabled="!template.contractSend"
                                :select-data="templateList"
                                :select-value="templateValueList"
                                :selected-value="template.templateSelectedIndex"
                                @update:set="(val) => onSelectTemplate(template, val)"
                            ></select-form>
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">메시지 내용</span>
                        </div>
                        <textarea
                            v-model="templateContentList[template.templateSelectedIndex]"
                            class="com-textarea resize-none contract-message-content"
                            maxlength="2000"
                            disabled
                        ></textarea>
                        <div class="content-count">
                            {{
                                templateContentList[template.templateSelectedIndex]
                                    ? templateContentList[template.templateSelectedIndex].length
                                    : 0
                            }}
                            / 2000byte
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">메시지 버튼</span>
                        </div>
                        <div class="general-input-component" style="margin-top: 5px">
                            <div class="com-radio">
                                <input
                                    type="radio"
                                    :name="`rdo_contract_${template.type}_${index}`"
                                    :id="`rdo_contract_not_used_${template.type}_${index}`"
                                    :value="false"
                                    v-model="template.messageButton"
                                    @change="onChangeMessageButton(template)"
                                />
                                <label :for="`rdo_contract_not_used_${template.type}_${index}`" class="label-black">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    type="radio"
                                    :name="`rdo_contract_${template.type}_${index}`"
                                    :id="`rdo_contract_link_${template.type}_${index}`"
                                    :value="true"
                                    v-model="template.messageButton"
                                    @change="onChangeMessageButton(template)"
                                />
                                <label :for="`rdo_contract_link_${template.type}_${index}`" class="label-black">링크</label>
                            </div>
                        </div>
                        <input
                            v-model="template.buttonName"
                            maxlength="8"
                            class="message-link"
                            placeholder="내용확인 및 서명하기"
                            type="text"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        />
                        <div
                            class="message-link"
                            style="display: flex"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        >
                            <input
                                v-model="template.linkMobile"
                                style="flex: 1"
                                placeholder="www.url.kr"
                                type="text"
                            />
                            <button
                                class="com-btn border-button line-blind"
                                @click="onCheckConnect(template)"
                                :disabled="template.linkMobile == '' || template.linkMobile == null"
                            >
                                연결확인
                            </button>
                        </div>
                        <input
                            v-model="template.linkPC"
                            class="message-link"
                            placeholder="www.url.kr"
                            type="text"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        />
                        <div class="message-link" style="display: flex; margin-top: 25px">
                            <button
                                class="com-btn"
                                style="flex: 1; margin-right: 10px; display: none"
                                @click="onCancel(template)"
                            >
                                취소
                            </button>
                            <button class="com-btn blue" style="flex: 1" @click="onSave(template)">저장</button>
                        </div>
                    </div>
                </div>
            </div>

            <p class="sub-title small"><strong>키오스크</strong></p>

            <div class="rectangle-box contract-send">
                <div v-for='(template, index) in kioskTemplates' style="width: 25%">
                    <div class="contract-send-item">
                        <div class="general-input-component" style="margin-top: 0">
                            <div class="input-title" style="flex: 1">{{ template.title }}</div>
                            <div class="line">
                                <div class="line-wrap">
                                    <div class="check">
                                        <div class="com-design-check">
                                            <input
                                                :id="`check-sms-${template.type}-${index}`"
                                                type="checkbox"
                                                v-model="template.contractSend"
                                            />
                                            <label :for="`check-sms-${template.type}-${index}`"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">
                                템플릿 선택
                                <span class="imp">*</span>
                            </span>
                            <select-form
                                style="flex: 1"
                                :disabled="!template.contractSend"
                                :select-data="templateList"
                                :select-value="templateValueList"
                                :selected-value="template.templateSelectedIndex"
                                @update:set="(val) => onSelectTemplate(template, val)"
                            ></select-form>
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">메시지 내용</span>
                        </div>
                        <textarea
                            v-model="templateContentList[template.templateSelectedIndex]"
                            class="com-textarea resize-none contract-message-content"
                            maxlength="2000"
                            disabled
                        ></textarea>
                        <div class="content-count">
                            {{
                                templateContentList[template.templateSelectedIndex]
                                    ? templateContentList[template.templateSelectedIndex].length
                                    : 0
                            }}
                            / 2000byte
                        </div>
                        <div class="general-input-component">
                            <span class="input-title">메시지 버튼</span>
                        </div>
                        <div class="general-input-component" style="margin-top: 5px">
                            <div class="com-radio">
                                <input
                                    type="radio"
                                    :name="`rdo_contract_${template.type}_${index}`"
                                    :id="`rdo_contract_not_used_${template.type}_${index}`"
                                    :value="false"
                                    v-model="template.messageButton"
                                    @change="onChangeMessageButton(template)"
                                />
                                <label :for="`rdo_contract_not_used_${template.type}_${index}`" class="label-black">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    type="radio"
                                    :name="`rdo_contract_${template.type}_${index}`"
                                    :id="`rdo_contract_link_${template.type}_${index}`"
                                    :value="true"
                                    v-model="template.messageButton"
                                    @change="onChangeMessageButton(template)"
                                />
                                <label :for="`rdo_contract_link_${template.type}_${index}`" class="label-black">링크</label>
                            </div>
                        </div>
                        <input
                            v-model="template.buttonName"
                            maxlength="8"
                            class="message-link"
                            placeholder="내용확인 및 서명하기"
                            type="text"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        />
                        <div
                            class="message-link"
                            style="display: flex"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        >
                            <input
                                v-model="template.linkMobile"
                                style="flex: 1"
                                placeholder="www.url.kr"
                                type="text"
                            />
                            <button
                                class="com-btn border-button line-blind"
                                @click="onCheckConnect(template)"
                                :disabled="template.linkMobile == '' || template.linkMobile == null"
                            >
                                연결확인
                            </button>
                        </div>
                        <input
                            v-model="template.linkPC"
                            class="message-link"
                            placeholder="www.url.kr"
                            type="text"
                            :style="`${!template.messageButton ? 'visibility: hidden;' : ''}`"
                        />
                        <div class="message-link" style="display: flex; margin-top: 25px">
                            <button
                                class="com-btn"
                                style="flex: 1; margin-right: 10px; display: none"
                                @click="onCancel(template)"
                            >
                                취소
                            </button>
                            <button class="com-btn blue" style="flex: 1" @click="onSave(template)">저장</button>
                        </div>
                    </div>
                </div>
            </div>

        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'notiBasic',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: {},
    computed: {
        isProfileComplete() {
            return (
                this.uuid !== null &&
                this.uuid !== undefined &&
                this.categoryCode !== null &&
                this.categoryCode !== undefined
            );
        },
        selectedCategoryName() {
            const category = this.categoryCodes.find((cat) => cat.code === this.categoryCode);
            return category ? category.name : null;
        },
    },
    watch: {
        async selectedCategoryCode(newVal) {
            const selectedCategory = this.categoryCodes.find((category) => category.name === newVal);
            if (selectedCategory) {
                this.categoryCode = selectedCategory.code; // categoryCode 데이터 속성에 값을 저장
                await this.fetchSubCategoryCodes(selectedCategory.code);
            } else {
                this.subCategoryCodes = [];
                this.selectedSubCategoryCode = '';
            }
        },
    },
    created() {},
    mounted() {
        this.init();
        this.fetchCategoryCodes();
        this.fetchKakaoProfile();
    },
    data() {
        return {
            isLoading: false,

            contractInfo: [],

            kioskTemplates: [],

            uuid: null,
            categoryCode: null,
            name: '',
            categoryCodes: [], // 카테고리 코드 목록
            selectedCategoryCode: '', // 사용자가 선택한 대분류 카테고리 코드
            subCategoryCodes: [], // 중분류 카테고리 코드 목록
            selectedSubCategoryCode: '', // 사용자가 선택한 중분류 카테고리 코드
            yellowId: '',
            phoneNumber: '',
            token: '',
            senderKey: null,

            templateData: null,
            templateList: ['템플릿 선택'],
            templateValueList: [0],
            templateIdList: [0],
            templateContentList: [''],
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;

            await this.getTemplates();

            await this.getContracts();

            await this.getKioskTemplates();

            this.isLoading = false;
        },

        onSelectTemplate(template, val) {
            template.templateSelectedIndex = val;
            if (val > 0) {
                template.messageButton = this.templateData[val - 1].messageButton;
                template.buttonName = this.templateData[val - 1].buttonName;
                template.linkMobile = this.templateData[val - 1].linkMobile;
                template.linkPC = this.templateData[val - 1].linkPC;
            }
        },

        async getTemplates() {
            try {
                const { data } = await api.get(`/admin/api/center/noti/talk/template/1`);
                if (data) {
                    this.templateData = data;
                    this.templateList = ['템플릿 선택'];
                    this.templateValueList = [0];
                    this.templateIdList = [0];
                    this.templateContentList = [''];

                    data.map((item, index) => {
                        this.templateList.push(item.title);
                        this.templateValueList.push(index + 1);
                        this.templateIdList.push(item.id);
                        this.templateContentList.push(item.content);
                    });
                }
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async getContracts() {
            try {
                const { data } = await api.get(`/admin/api/center/noti/talk/contract`);

                data.map((item) => {
                    item.templateSelectedIndex = this.templateIdList.indexOf(item.templateId);
                });

                this.contractInfo = data;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async getKioskTemplates() {
            try {
                const { data } = await api.get(`/admin/api/center/noti/talk/kiosk`);

                data.map((item) => {
                    item.templateSelectedIndex = this.templateIdList.indexOf(item.templateId);
                });

                this.kioskTemplates = data;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        // 페지 이동
        onClickRouter(path, menu = '', eventNum = '') {
            this.$router.push({
                path: `${path}`,
            });
        },

        onCheckConnect(template) {
            const linkUrl = template.linkMobile;

            if (linkUrl == '') {
                alert('모바일 URL 링크를 입력해 주세요.');
                return;
            }

            let link = document.createElement('a');
            link.href = linkUrl;
            link.target = '_blank';
            link.click();
        },

        onCancel(template) {},

        async onSave(template) {
            if (template.contractSend) {
                if (template.templateSelectedIndex == 0 || template.templateSelectedIndex == undefined) {
                    alert('템플릿을 선택해 주세요.');
                    return;
                }
            }

            if (template.messageButton) {
                if (template.messageButton == '') {
                    alert('버튼명을 입력해 주세요.');
                    return;
                }
                if (template.linkMobile == '') {
                    alert('모바일 링크 url을 입력해 주세요.');
                    return;
                }
                if (template.linkPC == '') {
                    alert('PC 링크 url을 입력해 주세요.');
                    return;
                }
            }

            try {
                if (template.id == 0) {
                    if (!confirm('알림톡메시지를 등록하시겠습니까?')) {
                        return;
                    }
                } else {
                    if (!confirm('알림톡메시지를 수정하시겠습니까?')) {
                        return;
                    }
                }

                template.templateId = this.templateIdList[template.templateSelectedIndex];
                delete template.templateSelectedIndex;

                const { data } = await api.post(`/admin/api/center/noti/talk/instance`, template);

                if (data) {
                    if (template.id == 0) {
                        alert('알림톡메시지가 등록되었습니다.');
                    } else {
                        alert('알림톡메시지가 수정되었습니다.');
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        resetFields() {
            this.yellowId = '';
            this.phoneNumber = '';
            this.token = '';
            this.selectedCategoryCode = '';
        },
        async registerProfile() {
            try {
                const response = await paymentApi.post(`/admin/api/kakao-talk-profile/register-profile/0`, {
                    yellowId: this.yellowId,
                    phoneNumber: this.phoneNumber,
                    categoryCode: this.categoryCode,
                    token: this.token,
                });
                if (response.data.response && response.data.response.resultMsg === '정상') {
                    alert('등록되었습니다.');
                } else {
                    alert(response.data.response.resultMsg);
                }
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data && error.response.data.error) {
                    alert(error.response.data.error.message);
                } else {
                    alert('오류가 발생하였습니다.');
                }
            }
        },
        async fetchKakaoProfile() {
            try {
                const response = await paymentApi.get(`/admin/api/kakao-talk-profile/get-center-kakao-profile/0`);
                this.name = response.data.name;
                this.uuid = response.data.plus_friend_id;
                this.categoryCode = response.data.category_code;
                this.senderKey = response.data.senderKey;
            } catch (error) {
                console.error(error);
            }
        },
        async fetchCategoryCodes() {
            try {
                const response = await paymentApi.get('/admin/api/kakaotalk/category/all');
                const categories = Array.isArray(response.data.data) ? response.data.data : response.data.data;
                const categoryCodes = categories.map((category) => ({ name: category.name, code: category.code })); // 객체 배열 생성

                const selectedCategories = [
                    '건강,심리치료/명상/기타대체의학',
                    '미용,미용,뷰티케어샵/체형클리닉',
                    '일반서비스,기타일반서비스,기타일반서비스',
                    '전문서비스,기타전문서비스,기타전문서비스',
                    '기타서비스,업무알림,업무알림',
                ];

                if (selectedCategories.length > 0) {
                    this.categoryCodes = categoryCodes.filter((category) => selectedCategories.includes(category.name));
                } else {
                    this.categoryCodes = [...categoryCodes];
                }
            } catch (error) {
                console.error('카테고리 코드 목록을 불러오는 데 실패했습니다:', error);
            }
        },
        async fetchSubCategoryCodes(categoryCode) {
            try {
                const response = await paymentApi.get(`/admin/api/kakaotalk/category/one/${categoryCode}`);
                const subCategories = response.data.data; // API 응답에서 중분류 카테고리 데이터를 가져옵니다.

                // 중분류 카테고리 데이터가 있는지 확인합니다.
                if (Array.isArray(subCategories)) {
                    // 중분류 카테고리 이름만 배열에 추가합니다.
                    const subCategoryNames = subCategories.map((subCategory) => subCategory.name);

                    // API 응답으로 받은 중분류 카테고리 이름을 subCategoryCodes 배열에 저장합니다.
                    this.subCategoryCodes = [...subCategoryNames];
                } else {
                    // 중분류 카테고리 데이터가 없습니다.
                    this.subCategoryCodes = ['중분류값이 없습니다'];
                }
            } catch (error) {
                console.error('중분류 카테고리 코드 목록을 불러오는 데 실패했습니다:', error);
                this.subCategoryCodes = [];
            }
        },
        updateSelectedCategoryCode(newValue) {
            this.selectedCategoryCode = newValue;
        },
        updateSelectedSubCategoryCode(newValue) {
            this.selectedSubCategoryCode = newValue;
        },
        async registerPlusFriend() {
            try {
                if (!this.yellowId) {
                    alert('플러스 친구 아이디를 입력해주세요.');
                    return;
                }
                if (!this.phoneNumber) {
                    alert('모바일 전화번호를 입력해 주세요');
                    return;
                }
                const response = await paymentApi.post(`/admin/api/kakao-talk-profile/request-profile-auth-token/`, {
                    yellowId: this.yellowId,
                    phoneNumber: this.phoneNumber,
                });

                if (response.data.result === 0 && response.data.code === '200') {
                    alert('인증번호가 발송되었습니다.');
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error(error);
                alert(error.response.data.message);
            }
        },

        async onChangeMessageButton(template) {
            if (!template.messageButton) {
                template.buttonName = '';
                template.linkMobile = '';
                template.linkPC = '';
            }
        },
    },
};
</script>
<style lang="scss"></style>
